"use client"

import { useDroppable } from "@dnd-kit/core"

import { cn } from "../../lib/utils"
import { useCalendarDnd } from "./calendar-dnd-context"

export function DroppableCell({
  id,
  date,
  time,
  children,
  className,
  onClick,
  style,
  resourceId,
  resourceType,
  disabled = false,
}) {
  const { activeEvent } = useCalendarDnd()

  const { setNodeRef, isOver } = useDroppable({
    id,
    disabled,
    data: {
      date,
      time,
      resourceId,
      resourceType,
    },
  })

  const formattedTime =
    time !== undefined
      ? `${Math.floor(time)}:${Math.round((time - Math.floor(time)) * 60)
          .toString()
          .padStart(2, "0")}`
      : null

  return (
    <div
      ref={setNodeRef}
      onClick={disabled ? undefined : onClick}
      className={cn(
        "data-dragging:bg-accent flex h-full flex-col overflow-hidden px-0.5 py-1 sm:px-1",
        className
      )}
      style={style}
      title={formattedTime ? `${formattedTime}` : undefined}
      data-dragging={isOver && activeEvent ? true : undefined}
      data-disabled={disabled || undefined}
    >
      {children}
    </div>
  )
}
